export const ru = {
    title: 'Ранний заезд и поздний выезд',
    description: 'Опция будет добавлена на этапе оформления услуги',
    choose_check_in: 'Выбрать время заезда...',
    choose_check_out: 'Выбрать время выезда...',
    early_check_in: 'Ранний заезд',
    late_check_out: 'Поздний выезд',
};
